import type { FC } from 'react';
import { memo } from 'react';

import { useFormatDate } from './useFormatDate'

export interface IDateProps {
  date?: string | Date
}

export const FormattedDate: FC<IDateProps> = memo(
  ({ date = new Date() }) => {
    const formatDate = useFormatDate()

    return <span>{formatDate(date)}</span>
  }
)

FormattedDate.defaultProps = {
  date: new Date(),
}
FormattedDate.displayName = 'FormattedDate'
